var exports = {
  "h": "x31de4314--f2ee5c--description",
  "F": "x31de4314--f2ee5c--description-coworking",
};

module.exports = exports;
